import {Spinner} from "@fluentui/react-components";

function ProgressRing() {
    return (
        <Spinner/>
    );
}

export default ProgressRing;